import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
// import MockService from "@/core/mock/mock.service";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import * as rules from 'vee-validate/dist/rules';
import moment from 'moment';
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin';
import VueAnalytics from 'vue-analytics';
import Hotjar from 'vue-hotjar';
import config from "@/config/app.js";

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
});
localize('en', en)

Vue.config.productionTip = false;
// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-193558133-1',
  ecommerce: {
    enabled: true,
    enhanced: true
  },
  router
});

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

Vue.use(VueCookieBot, {
  cookieBotID: 'e4b0d7c6-4901-4512-a96b-e7841c44f184'
});
Vue.use (Hotjar, {
  id: config.HOTJAR_ID,
  isProduction: config.PROD_MODE,
});
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD / MMM / YYYY')
  }
});

Vue.filter('currencyFormat', function (value) {
  if (value) {
    return value.replace(".", ",")
  }
})

Vue.filter('priceFormat', function (value) {
  let num = ""
  if(value) {
    if (value.indexOf(",") !== -1) {
      num = value.replace(",", ".")
    } else {
      num = value
    }
    let formatted = parseFloat(num).toFixed(2)
    return formatted.toString().replace(".", ",")
  }
})

Vue.filter('DateFormat', function (value) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY");
  }
});

Vue.filter('lowerPriceFilter', function (value) {
  let priceArr = []
      value.forEach((item) => {
        let price = item.price.replace(",", ".")
         priceArr.push(parseFloat(price));
      });
      return Math.min.apply( Math, priceArr ).toFixed(2).toString().replace(".", ",");
})

Vue.filter('higherPriceFilter', function (value) {
  let priceArr = []
      value.forEach((item) => {
        let price = item.price.replace(",", ".")
         priceArr.push(parseFloat(price));
      });
      return Math.max.apply( Math, priceArr ).toFixed(2).toString().replace(".", ",");
})

Vue.filter('lowerRangeFilter', function (value) {
  let qtyArr = []
      value.forEach((item) => {
        let qty = item.unit_quantity
         qtyArr.push(parseFloat(qty));
      });
      return Math.min.apply( Math, qtyArr )
})

Vue.filter('higherRangeFilter', function (value) {
  let qtyArr = []
      value.forEach((item) => {
        let qty = item.unit_quantity
         qtyArr.push(parseFloat(qty));
      });
      return Math.max.apply( Math, qtyArr )
})

Vue.filter('dashboardProductTotalQtyPrice', function (value) {
      let qty = value.quantity
      let price = value.unit_price.replace(",", ".")
      let total = parseFloat(qty) * parseFloat(price)
      return total.toFixed(2).toString().replace(".", ",")
})

// API service init
ApiService.init();

// Remove this to disable mock API
// MockService.init();

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // if(to.meta.adminAuth){
  //   const userRole = localStorage.getItem('bar_book_a_room_user_access_role')
  //   if(userRole === 'admin'){
  //     alert('here')
  //     next()
  //   } else {
  //     next('/provider')
  //   }
  // } 
  // else if(to.meta.providerAuth){
  //   const userRole = localStorage.getItem('bar_book_a_room_user_access_role')
  //   if(userRole === 'provider'){
  //     next()
  //   } else {
  //     next('/admin')
  //   }
  // }

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  document.title = 'GUSTOREICH | ' + to.meta.title

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  i18n,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount("#app");
